import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroParteEntePublico extends Filtro {
    tipo = 'booleano';

    get label() {
        return 'Com parte ente público';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        if (this.store.mapaProcessosPartes) {
            let partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];
            if (partesProcesso?.partes) {
                return partesProcesso.partes.findIndex((parte) => parte.entePublico) !== -1;
            }
        }
        return false;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    renderCarregando() {
        return this.renderCircularProgress('partes dos processos');
    }
}
